module.exports = "<div *ngIf=\"!mostrarListado\" class=\"table-explain\">\n  <div class=\"table-explain-center\">\n      <i class=\"icon-explain mdi mdi-arrow-left-bold-circle\"></i>\n      <p class=\"title-explain\">Mostrar listado</p>\n      <button *ngIf=\"addPermission\" (click)=\"add()\" class=\"btn btn-rounded btn-success right-bar-to w-75\">\n          <i class=\"mdi mdi-plus-circle\"></i> {{ addText }}\n      </button>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/catalogo-lista-default/catalogo-lista-default.component.html
// module id = ./src/app/components/partials/catalogo-lista-default/catalogo-lista-default.component.html
// module chunks = main